<template>
  <div class="build" :class="'no'+type">
    <div>{{text}}
      <el-button type="primary" v-if="type=='cart'" @click="goto(type)">继续购物</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'build',
  components: {},
  data() {
    return {
      newtype: this.type
    }
  },
  props: {
    text: String,
    type: String
  },
  mounted() {},
  created() {},
  methods: {
    goto(val) {
      if (val == 'cart') {
        this.$router.push({
          path: '/'
        })
      }
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/nonull.vue